import React, { createContext, useEffect, useState } from "react";
import {toast} from "react-toastify";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedEmail = localStorage.getItem("userEmail");
        const storedToken = localStorage.getItem("token");

        if (storedEmail && storedToken) {
            setUser({ email: storedEmail });
            setToken(storedToken);
            toast.info("Kullanıcı oturumu geri yüklendi");
        }

        setLoading(false);
    }, []);

    const login = (email, token, firstName, lastName, id) => {
        if (!token || !email) {
            toast.error("Geçersiz giriş yanıtı – token veya email eksik!");
            return;
        }

        localStorage.setItem("token", token);
        localStorage.setItem("userEmail", email);
        localStorage.setItem("userName", firstName + " " + lastName);
        localStorage.setItem("userId", id);
        setUser({ email, firstName, lastName, role: "user" });
        setToken(token);
        toast.success("Giriş başarılı! Hoş geldiniz 👋");
    };


    const logout = () => {
        setUser(null);
        setToken(null);

        localStorage.removeItem("userEmail");
        localStorage.removeItem("token");
        localStorage.removeItem("userName");

        toast.info("Çıkış yapıldı 👋");
    };

    return (
        <AuthContext.Provider value={{ user, token, login, logout, loading }}>
            {children}
        </AuthContext.Provider>

    );
};

export default AuthContext;
